export default __webpack_public_path__ + "static/Plots0003-8451bb6ffada8d984370aa43fee86a0b.jpg";